// extracted by extract-css-chunks-webpack-plugin
module.exports = {"heading":"css-2VTF9Kpg4p","heading_inner":"css-7gokYh9j6e","heading__wideWidth":"css-65EuKf-r0T","heading__fullWidth":"css-ZwLZqvca37"};